import * as React from "react";
import { RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import LoadingFullScreen from "../../../components/LoadingFullScreen";
import { RootState, NavigationStep, Page } from "../../types";
import Appointments from "../components/Appointments";
import "./AppointmentsDemoContainer.scss";
import { setPatientAndAct } from "../../patient/actions";
import { Patient, PatientFormParams } from "../../patient/types";
import AddAppointment from "../components/AddAppointment";
import Select from "react-select";
import { FormikErrors } from "formik";
import { addPatient } from "../../patient/actions";
import DatePicker from "react-datepicker";
import moment from "moment";
import { Appointment, AppointmentStatus } from "../types";
import SmsPresentation from "../components/SmsPresentation";

interface StoreProps {
  loading: boolean;
  patientList: Page<Patient>;

  locations: string[];
}

interface DispatchProps {
  setPatientAndAct: (patient: Patient, step: NavigationStep) => void;
  addPatient: (
    params: PatientFormParams,
    onError: (error: FormikErrors<PatientFormParams>) => void
  ) => void;
}

interface OwnState {
  isBusy: boolean;
  appointmentDate: Date;
  showMessages: boolean;
  showConfig: boolean;
  appointments: Appointment[];
  showSms: boolean;
  smsStatus: AppointmentStatus | null;
}

const ExampleCustomInput = ({ value, onClick }) => (
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions
  <div className="date-selection message-button custom-input" onClick={onClick}>
    <i className="far fa-calendar-alt"></i>
    {moment(value).format("dddd - LL")}
  </div>
);

type Props = OwnState & DispatchProps & StoreProps & RouteComponentProps;

class AppointmentsDemoContainer extends React.PureComponent<Props, OwnState> {
  public constructor(props: Props) {
    super(props);

    this.state = {
      isBusy: false,
      appointmentDate: new Date(),
      showConfig: false,
      showMessages: false,
      appointments: this.showAllStates(),
      showSms: false,
      smsStatus: null
    };
    this.showAllStates();
  }

  private showAllStates = () => {
    return [
      {
        id: 1,
        name: "Apple, Jones",
        time: moment().set({ hour: 8, minutes: 0 }),
        status: AppointmentStatus.scheduled
      },
      {
        id: 1,
        name: "Bronner, James",
        time: moment().set({ hour: 11, minutes: 0 }),
        status: AppointmentStatus.confirmation_request_sent
      },
      {
        id: 1,
        name: "Carley, Brian",
        time: moment().set({ hour: 11, minutes: 0 }),
        status: AppointmentStatus.confirmed
      },
      {
        id: 1,
        name: "Brant, Lisa",
        time: moment().set({ hour: 14, minutes: 0 }),
        status: AppointmentStatus.late
      },
      {
        id: 1,
        name: "Haggs, Marvin",
        time: moment().set({ hour: 15, minutes: 0 }),
        status: AppointmentStatus.waiting
      },
      {
        id: 1,
        name: "Kelvin, Randy",
        time: moment().set({ hour: 15, minutes: 0 }),
        status: AppointmentStatus.entrance_request
      },
      {
        id: 1,
        name: "Leu, Mary",
        time: moment().set({ hour: 16, minutes: 0 }),
        status: AppointmentStatus.in_treatment
      },
      {
        id: 1,
        name: "Rogers, Wayne",
        time: moment().set({ hour: 16, minutes: 30 }),
        status: AppointmentStatus.complete
      },
      {
        id: 1,
        name: "Smith, Ruth",
        time: moment().set({ hour: 16, minutes: 30 }),
        status: AppointmentStatus.cancelled
      }
    ];
  };

  private showNewAppointments = () => {
    this.setState({
      showSms: false,
      smsStatus: null,
      appointments: [
        {
          id: 1,
          name: "Apple, Jones",
          time: moment().set({ hour: 8, minutes: 0 }),
          status: AppointmentStatus.scheduled
        }
      ]
    });
  };

  private messageTemplates = () => {
    return [
      { value: "Appointment Reminder", label: "Appointment Reminder" },
      { value: "Morning Of", label: "Morning Of" },
      { value: "Ready to see you", label: "Ready to see you" }
    ];
  };

  private setStartDate = (date: Date) => {
    this.setState({ appointmentDate: date });
  };

  private showConfigChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ showConfig: e.target.checked });
  };

  private showMessageChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ showMessages: e.target.checked });
  };

  private toggleMessageFamily = () => {};

  updateStatus = (state: AppointmentStatus) => {
    this.setState(prevState => {
      const updateAppointments = [...prevState.appointments];
      updateAppointments.forEach(x => (x.status = state));
      return {
        appointments: updateAppointments,
        showSms: true,
        smsStatus: state
      };
    });
  };

  patientResponse = (status: AppointmentStatus) => {
    this.setState(prevState => {
      const updateAppointments = [...prevState.appointments];
      updateAppointments.forEach(x => (x.status = status));
      return { appointments: updateAppointments, smsStatus: status };
    });
    if (status === AppointmentStatus.confirmed) {
      setTimeout(() => {
        this.setState({ smsStatus: AppointmentStatus.arrival_response_sent });
      }, 3000);
    }
    if (status === AppointmentStatus.waiting) {
      setTimeout(() => {
        this.setState({ smsStatus: AppointmentStatus.paperwork });
      }, 1000);
    }
    if (status === AppointmentStatus.cancelled) {
      setTimeout(() => {
        this.setState({ smsStatus: AppointmentStatus.cancelled_response });
      }, 3000);
    }
    if (status === AppointmentStatus.late) {
      setTimeout(() => {
        this.setState({ smsStatus: AppointmentStatus.late_response });
      }, 3000);
    }
  };

  public render() {
    const { loading } = this.props;
    const { appointments, showSms, smsStatus } = this.state;
    return (
      <>
        {loading && <LoadingFullScreen />}

        <div className="sections appointment-container">
          <div className="config-options actions">
            <label htmlFor="showConfig">
              <input
                id="showConfig"
                type="checkbox"
                defaultChecked={this.state.showConfig}
                onChange={event => this.showConfigChanged(event)}
              />{" "}
              Show Configuration
            </label>
            <label htmlFor="showMessages">
              <input
                id="showMessages"
                type="checkbox"
                defaultChecked={this.state.showConfig}
                onChange={event => this.showMessageChanged(event)}
              />{" "}
              Show Message
            </label>
            <button className="mt-10" onClick={() => this.showNewAppointments()}>
              New Appointment Flow
            </button>
          </div>

          {showSms && (
            <SmsPresentation smsStatus={smsStatus} patientResponse={this.patientResponse} />
          )}

          <div className="full-width p-15 flex-between-center">
            <DatePicker
              selected={this.state.appointmentDate}
              onChange={(date: Date) => this.setStartDate(date)}
              customInput={<ExampleCustomInput />}
            />

            <div className="flex-center">
              <AddAppointment
                setPatientAndAct={setPatientAndAct}
                patientList={this.props.patientList}
                action={this.props.addPatient}
                locations={this.props.locations}
              />
              <button className="ml-15">Upload Patient Appointments</button>
            </div>
          </div>

          {this.state.showConfig && (
            <div className="section p-15 mb-25">
              <h1>Configuration</h1>
              <div>
                <label htmlFor="url-billing">Billing URL</label>
                <input type="text" id="url-billing"></input>
                <label htmlFor="url-paperwork">Paperwork URL</label>
                <input type="text" id="url-paperwork"></input>
                <label htmlFor="url-schedule">Schedule URL</label>
                <div className="flex-center">
                  <div className="flex-1">
                    <input type="text" id="url-schedule"></input>
                  </div>
                  <div style={{ width: "250px" }} className="ml-15">
                    <Select
                      id="message-templates"
                      className="full-width mr-15"
                      options={this.messageTemplates()}
                    />
                  </div>
                </div>

                <div className="bold mt-25 mb-10">Message Templates</div>
                <Select
                  id="message-templates"
                  className="full-width mr-15"
                  options={this.messageTemplates()}
                />
                <label htmlFor="template-title">Title</label>
                <input type="text" id="template-title"></input>
                <label htmlFor="template-body">Message</label>
                <textarea id="template-body"></textarea>
              </div>
            </div>
          )}

          <Appointments
            appointments={appointments}
            showMessages={this.state.showMessages}
            updateStatus={this.updateStatus}
            toggleMessageFamily={this.toggleMessageFamily}
          />

          <div className="section p-15 mb-25 mt-25 actions">
            <h1>Actions</h1>
            <small>Could all be automated and can go to Configuration</small>
            <div className="flex-between-center">
              <button
                onClick={() => this.updateStatus(AppointmentStatus.confirmation_request_sent)}
              >
                Send Confirmation Request
              </button>
              <div>
                <label htmlFor="include-paperwork">
                  <input id="include-paperwork" type="checkbox" /> Include Paperwork Link
                </label>

                <label htmlFor="include-billing">
                  <input id="include-billing" type="checkbox" /> Include Outstanding Billing
                </label>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect<StoreProps, DispatchProps, {}, RootState>(
  state => ({
    loading: state.dashboard.loading,
    patientList: state.dashboard.data.patientList,
    locations: state.dashboard.data.locations
  }),
  { addPatient, setPatientAndAct }
)(AppointmentsDemoContainer);
